module.exports = __webpack_public_path__ + "img/favorites.a79913ab.png";